export const REQUEST_FILTERS = "[filters] REQUEST_FILTERS";
export const RECEIVE_FILTERS = "[filters] RECEIVE_FILTERS";

export const SEARCH_OPTION_SELECTED = "[filters] SEARCH_OPTION_SELECTED";